import { useTranslation } from "react-i18next";

export enum IGNORED_FILTER_OPTIONS {
  HideIgnored = 1,
  HideUnignored,
  ShowAll
}

export const useIgnoredOptions = () => {
  const { t } = useTranslation();

  return [
    { key: IGNORED_FILTER_OPTIONS.HideIgnored, value: IGNORED_FILTER_OPTIONS.HideIgnored, text: t("v8_hide_ignored_licenses", "Hide Ignored Licenses") },
    { key: IGNORED_FILTER_OPTIONS.HideUnignored, value: IGNORED_FILTER_OPTIONS.HideUnignored, text: t("v8_hide_unignored_licenses", "Hide Unignored Licenses") },
    { key: IGNORED_FILTER_OPTIONS.ShowAll, value: IGNORED_FILTER_OPTIONS.ShowAll, text: t("v8_show_all", "Show All") }
  ];
};
